export default __webpack_public_path__ + "static/media/card1-2.3edae9b0.jpg";